/* eslint no-useless-escape: 0 */

import VeeValidate, { Validator } from 'vee-validate'
import {
  getAmountWithAppliedFeeIfItExists,
  getFormattedItemFee
} from '../mixins/item-fee-mixin'

export const EMAIL_REGEX =
  "[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?"
export const COMMA_SEPARATED_EMAIL_REGEX =
  '^([\\w+-.%]+@[\\w-.]+\\.[A-Za-z]{2,4},?\\s*)+$'
export const DISPLAY_NAME_REGEX = '^[-a-zA-Z0-9 _]{5,100}$'
export const PHONE_NUMBER_REGEX = '^\\(?\\d{3}\\)?[- ]?\\d{3}[- ]?\\d{4}$'

// These are matching what we currently use in the TC-Validators library
export const ADDRESS_XSS_FIELD = '^[^<>"/]*$'
export const QUOTED_XSS_FIELD = '^[^<>/]*$'

function ValidatorPlugin (Vue) {
  Vue.use(VeeValidate)

  Validator.extend('displayName', {
    getMessage: field => 'The ' + field + ' value is not a valid display name.',
    validate: value =>
      Boolean(!!value && value.match(new RegExp(DISPLAY_NAME_REGEX)))
  })

  Validator.extend('unique', {
    getMessage: field => 'The ' + field + ' value is not unique.',
    validate: (value, list) => Boolean(!!list && !list.includes(value))
  })

  Validator.extend('exists', {
    getMessage: field => 'The ' + field + ' value is not present.',
    validate: (value, list) => Boolean(!!list && list.includes(value))
  })

  Validator.extend('commaSeparatedEmail', {
    getMessage: field =>
      'The ' + field + ' value is not a valid comma separated email list.',
    validate: value =>
      Boolean(!!value && value.match(new RegExp(COMMA_SEPARATED_EMAIL_REGEX)))
  })

  Validator.extend('emailRegex', {
    getMessage: field => 'The ' + field + ' value is not a valid email.',
    validate: value => Boolean(!!value && value.match(new RegExp(EMAIL_REGEX)))
  })

  Validator.extend('phone', {
    getMessage: field => 'The ' + field + ' value is not a valid phone number.',
    validate: value =>
      Boolean(!!value && value.match(new RegExp(PHONE_NUMBER_REGEX)))
  })

  Validator.extend('matches', {
    getMessage: field => 'The ' + field + ' value does not match the original',
    validate: (value, args) => {
      return value === args[0]
    }
  })

  Validator.extend('numbersEqual', {
    getMessage: field => 'The ' + field + ' value is not valid',
    validate: (a, b) => {
      return (
        parseFloat(parseFloat(a).toFixed(2)) ===
        parseFloat(parseFloat(b).toFixed(2))
      )
    }
  })

  Validator.extend('feeCheck', {
    getMessage:
      'You do not have enough balance remaining for this selection after applied fee. Please choose a different option.',
    validate: (value, [availableBalance, item]) => {
      let itemFee
      if (item.fee) {
        itemFee = item.fee
      } else {
        // used whenever an item that is NOT a formatted cart item is being validated
        itemFee = item.adjustment
      }
      const formattedItemFee = getFormattedItemFee(value, itemFee)
      const costWithFee = getAmountWithAppliedFeeIfItExists(
        value,
        formattedItemFee
      )
      return costWithFee <= availableBalance
    }
  })

  Validator.extend('remainingBalance', {
    getMessage:
      'You do not have enough balance remaining for this selection. Please choose a different option.',
    validate: (value, [availableBalance]) => {
      const numericValue = parseFloat(value)
      return numericValue <= availableBalance
    }
  })

  Validator.extend('addressXss', {
    getMessage: field =>
      field + "must not contain any of the following: ', <, >, or / ",
    validate: value =>
      Boolean(!!value && value.match(new RegExp(ADDRESS_XSS_FIELD)))
  })

  Validator.extend('quotedXss', {
    getMessage: field =>
      field + 'must not contain any of the following: \', ", <, >, or / ',
    validate: value =>
      Boolean(!!value && value.match(new RegExp(QUOTED_XSS_FIELD)))
  })
}

export { ValidatorPlugin }
